import { Button, Modal, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ClientApi from '../../../Api/ClientApi';
import { Contact } from '../../../Models/Contact';

export default function ClientContactModal({
  show,
  setShow,
  getContacts,
  clientId,
  selectedContact,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  clientId: number;
  getContacts: () => Promise<void> | undefined;
  selectedContact: Contact | null;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const [formData, setFormData] = useState<Contact>({
    id: 0,
    clientId: clientId,
    firstName: '',
    lastName: '',
    phone: null,
    email: null,
    dob: null,
    dateAdded: new Date(),
    guid: '00000000-0000-0000-0000-000000000000',
  });

  const handleSetInitialValues = () => {
    const values = selectedContact
      ? {
          ...selectedContact,
        }
      : {
          id: 0,
          clientId: clientId,
          firstName: '',
          lastName: '',
          phone: null,
          email: null,
          dob: null,
          dateAdded: new Date(),
          guid: '00000000-0000-0000-0000-000000000000',
        };
    setFormData(values as Contact);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [selectedContact]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      clientId: clientId,
      firstName: '',
      lastName: '',
      phone: null,
      email: null,
      dob: null,
      dateAdded: new Date(),
      guid: '00000000-0000-0000-0000-000000000000',
    };
    setFormData(values as Contact);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    return await ClientApi.addUpdateContact(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success('Save Success');
          setIsLoading(false);
          setButtonDisabled(false);
          handleResetFormValues();
          getContacts();
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <Modal show={show} size='2xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>
                  {selectedContact ? 'Edit' : 'Add'} Contact
                </h1>
              </div>
            </div>
          </div>
          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                <div className='w-full'>
                  <div className='bg-white'>
                    <hr className='bg-gray-300 h-[5px]'></hr>
                    <form id='contactForm' onSubmit={onSubmit}>
                      <div className='text-gray-500'>
                        <div className='grid grid-cols-[35%_65%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Name:
                            </div>
                          </div>
                          <div className='flex'>
                            <div className='w-1/2'>
                              <TextInput
                                id='firstName'
                                name='firstName'
                                type='text'
                                placeholder='First...'
                                onChange={handleChangeInput}
                                value={formData.firstName ?? ''}
                                sizing='md'
                                required
                              />
                            </div>
                            <div className='w-1/2'>
                              <TextInput
                                id='lastName'
                                name='lastName'
                                type='text'
                                placeholder='Last...'
                                onChange={handleChangeInput}
                                value={formData.lastName ?? ''}
                                sizing='md'
                              />
                            </div>
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[35%_65%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Phone:
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='phone'
                              name='phone'
                              type='text'
                              placeholder='Phone...'
                              onChange={handleChangeInput}
                              value={formData.phone ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[35%_65%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Email:
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='email'
                              name='email'
                              type='text'
                              placeholder='Email...'
                              onChange={handleChangeInput}
                              value={formData.email ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className='flex justify-end pt-2'>
                      <Button
                        disabled={buttonDisabled}
                        type='submit'
                        form='contactForm'
                        className='buttonMain'
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
